import { Component, OnInit } from '@angular/core';
import {PartnerWalletService} from '../../../partner-wallet.service';
import {
  AppUserPartnerWalletAccess,
  AppUserPartnerWalletAccessSlim, AppUserPartnerWalletAccessStatus
} from '../../../dto/app-user-partner-wallet-access-slim';
import {ToastService} from 'angular-toastify';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-wallet-user-view',
  templateUrl: './wallet-user-view.component.html',
  styleUrls: ['./wallet-user-view.component.css']
})
export class WalletUserViewComponent implements OnInit {

  inviteId: number;
  invite: AppUserPartnerWalletAccess;
  status: AppUserPartnerWalletAccessStatus;
  isLoading: boolean;

  constructor(
    private partnerWalletService: PartnerWalletService,
    private _toastService: ToastService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {

    this.inviteId = parseInt(this.route.snapshot.paramMap.get('inviteId'));


    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.partnerWalletService.getInvite(this.inviteId).subscribe(invite => {
      this.invite = invite;
      this.isLoading = false;
    }, err => {
      this._toastService.error(err.error);
      this.isLoading = false;
    });
  }

}
